import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPIGeofences {
    //This method returns all of an organization's geofences.
    getAllGeofences() {
        return fetchJSON("/geofences");
    }
    //This method returns a single geofence by its unique ID.
    getSpecificGeofence(geofenceID) {
        return fetchJSON(`/geofences/${geofenceID}`);
    }
    //This method creates a new geofence.
    createNewGeofence(params) {
        return fetchJSON("/geofences", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method modifies the name or boundary of a geofence.
    modifyExistingGeofence(geofenceID, params) {
        return fetchJSON(`/geofences/${geofenceID}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes an existing geofence.
    deleteExistingGeofence(geofenceID) {
        return fetchWithAuth(`/geofences/${geofenceID}`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-geofences.js.map